import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiRequest {
    constructor() {

    }

    confirm() {
    }

    notify() {
    }

    proceed() {
    }

    requestColor() {
    }

    requestDir() {
    }

    requestedBlue() {
    }

    requestedGreen() {
    }

    requestedRed() {
    }

    requestFile() {
    }

    requestFont() {
    }
}
